import styled from '@emotion/styled';

const GoogleMapContainer = styled.div`
  max-height: 350px;
  overflow: hidden;

  .gatsby-image-wrapper {
    margin: -50% 0 0 0;
  }
`;

export { GoogleMapContainer };
